import React from 'react';
import { Helmet } from 'react-helmet';

import { seoTypes } from '../types/propTypes';

const SEO = ({ title, description, image }) => {
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      {image && <meta name="twitter:card" content="summary_large_image" />}
    </Helmet>
  );
};

SEO.propTypes = seoTypes;

export default SEO;
